// extracted by mini-css-extract-plugin
export default {"container":"Virtual_container__TPfPu","left":"Virtual_left__epp06","right":"Virtual_right__Nt+Zr","wrapper":"Virtual_wrapper__AQH-U"};